"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var tracker = _interopRequireWildcard(require("./lib/tracker"));

var ExposureLogger =
/*#__PURE__*/
function () {
  function ExposureLogger(experimentInstance) {
    (0, _classCallCheck2.default)(this, ExposureLogger);
    this._experiment = experimentInstance;
    this._hasLogged = false;
    this._tracker = null;
  }

  (0, _createClass2.default)(ExposureLogger, [{
    key: "logExposure",
    value: function logExposure() {
      var extras = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.initializeTracker();

      if (!this._experiment.inExperiment() || !this._tracker) {
        return;
      }

      this._hasLogged = true;
      this.formatAndLog(extras);
    }
  }, {
    key: "previouslyLogged",
    value: function previouslyLogged() {
      return this._hasLogged;
    }
  }, {
    key: "formatAndLog",
    value: function formatAndLog(extras) {
      var eventProperties = this.getEventProperties(extras);
      tracker.trackExposure(this._tracker.track, eventProperties);
    }
  }, {
    key: "getReportedParam",
    value: function getReportedParam() {
      var params = this._experiment.getParams();

      return Object.keys(params).map(function (key) {
        return key + ":" + params[key];
      }).join('|');
    }
  }, {
    key: "getEventProperties",
    value: function getEventProperties(extras) {
      var reportedParam = this.getReportedParam();

      var name = this._experiment.getName();

      var eventProperties = {
        experimentName: name,
        experimentParams: reportedParam
      };

      if (extras) {
        Object.keys(extras).forEach(function (extraKey) {
          eventProperties[extraKey] = extras[extraKey];
        });
      }

      return eventProperties;
    }
  }, {
    key: "initializeTracker",
    value: function initializeTracker() {
      if (this._tracker) {
        return;
      }

      var version = this._experiment.version || 'v1';
      this._tracker = tracker.create(version);
    }
  }]);
  return ExposureLogger;
}();

var _default = ExposureLogger;
exports.default = _default;
module.exports = exports.default;